import { takeLatest, select, cancel, put } from 'redux-saga/effects';
import size from 'lodash/size';

import * as pendingAssignments from '../assignment-pending-req';
import * as reviewedAssignments from '../assignment-reviewed-req';
import {
  selectPendingAssignmentListPagination,
  selectPendingAssignmentListCount,
  selectPendingAssignmentList,
  selectReviewedAssignmentListPagination,
  selectReviewedAssignmentListCount,
  selectReviewedAssignmentList,
} from '../selectors';

function* loadMorePendingAssignments() {
  const pagination = yield select(selectPendingAssignmentListPagination);
  const counter = yield select(selectPendingAssignmentListCount);
  const list = yield select(selectPendingAssignmentList);
  const listSize = size(list);

  if (counter <= listSize) {
    yield cancel();
  }

  yield put(
    pendingAssignments.paginationActions.send({
      ...pagination,
      offset: listSize,
    }),
  );
}
function* loadMoreReviewedAssignments() {
  const pagination = yield select(selectReviewedAssignmentListPagination);
  const counter = yield select(selectReviewedAssignmentListCount);
  const list = yield select(selectReviewedAssignmentList);
  const listSize = size(list);

  if (counter <= listSize) {
    yield cancel();
  }

  yield put(
    reviewedAssignments.paginationActions.send({
      ...pagination,
      offset: listSize,
    }),
  );
}

export default function* assignmentListPagination() {
  yield takeLatest(
    [pendingAssignments.consts.LOAD_MORE],
    loadMorePendingAssignments,
  );

  yield takeLatest(
    [reviewedAssignments.consts.LOAD_MORE],
    loadMoreReviewedAssignments,
  );
}



// WEBPACK FOOTER //
// ./src/redux/dependentManagement/sagas/assignmentListPagination.js